import AdminInvitesSection from '../../components/admin/AdminInvitesSection'
import AdminOnboardingSection from '../../components/admin/AdminOnboardingSection'
import AdminHeader from '../../components/admin/AdminHeader'
import { useNavigate } from 'react-router-dom'

export default function InvitesPage() {
  const navigate = useNavigate()
  const goBack = () => navigate('/admin')

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="flex items-center gap-3">
            <button type="button" onClick={goBack} className="text-sm text-gray-500 hover:text-gray-700">
              ← Back
            </button>
            <h2 className="text-lg font-semibold text-gray-800">Invites &amp; Onboarding</h2>
          </div>
          <AdminInvitesSection />
          <AdminOnboardingSection />
        </div>
      </div>
    </div>
  )
}
